export const PROFILE_TITLE_MAX_CHARACTERS = 60;
export const PROFILE_BIO_MAX_CHARACTERS = 400;

export const QUALITY_PROFILE_MIN_EXTERNAL_LINKS = 2;

export const PROFILE_MIN_SKILLS = 1;
export const PROFILE_MAX_SKILLS = 3;
export const PROFILE_MAX_EXTERNAL_LINKS = 7;
export const PROFILE_EXTERNAL_LINK_LABEL_MAX_CHARS = 25;

export const PROFILE_URL_MAX_LENGTH = 32;
export const PROFILE_URL_MIN_LENGTH = 8;
export const PROFILE_URL_REGEX = /^\w+$/;
